export interface FetchManufacturersQueryParam {
    id: string | number;
    name: string;
    business_name: string;
    id_number: string;
    email: string;
    phone_number: string;
    product_id: string;
    page: string | number;
    order_by: string;
    order_direction: 'asc' | 'desc';
    per_page: number | string;
}